import { useCallback } from 'react';

import { useResignDispositionMutation } from '../store/api';

/** Author controls for the reopened-note re-sign reminder queue. */
export function useResignDisposition() {
  const [dispositionMutation, { isLoading: isUpdating }] = useResignDispositionMutation();

  const dismiss = useCallback(
    async (noteId: string) =>
      dispositionMutation({
        noteId,
        resignDispositionRequest: { action: 'dismiss' },
      }).unwrap(),
    [dispositionMutation],
  );

  const remindTomorrow = useCallback(
    async (noteId: string) => {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(9, 0, 0, 0);
      return dispositionMutation({
        noteId,
        resignDispositionRequest: {
          action: 'snooze',
          snooze_until: tomorrow.getTime() / 1000,
        },
      }).unwrap();
    },
    [dispositionMutation],
  );

  const restore = useCallback(
    async (noteId: string) =>
      dispositionMutation({
        noteId,
        resignDispositionRequest: { action: 'clear' },
      }).unwrap(),
    [dispositionMutation],
  );

  return { dismiss, remindTomorrow, restore, isUpdating };
}
